import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import { Field } from 'react-final-form';

import css from './FieldCheckbox.module.css';

const IconCheckbox = props => {
  const { className, checkedClassName, boxClassName, availabilityForm, checkoutPage, orderPanel } = props;
  return (
    // <svg className={className} width="14" height="14" xmlns="http://www.w3.org/2000/svg">
    //   <g fill="none" fillRule="evenodd">
    //     <g transform="translate(2 2)">
    //       <path
    //         className={checkedClassName || css.checked}
    //         d="M9.9992985 1.5048549l-.0194517 6.9993137C9.977549 9.3309651 9.3066522 10 8.4798526 10H1.5001008c-.8284271 0-1.5-.6715729-1.5-1.5l-.000121-7c0-.8284271.6715728-1.5 1.5-1.5h.000121l6.9993246.0006862c.8284272.000067 1.4999458.671694 1.499879 1.5001211a1.5002208 1.5002208 0 0 1-.0000059.0040476z"
    //       />
    //       <path
    //         className={boxClassName || css.box}
    //         strokeWidth="2"
    //         d="M10.9992947 1.507634l-.0194518 6.9993137C10.9760133 9.8849417 9.8578519 11 8.4798526 11H1.5001008c-1.3807119 0-2.5-1.1192881-2.5-2.4999827L-1.0000202 1.5c0-1.3807119 1.119288-2.5 2.500098-2.5l6.9994284.0006862c1.3807118.0001115 2.4999096 1.11949 2.4997981 2.5002019-.0000018.003373-.0000018.003373-.0000096.0067458z"
    //       />
    //     </g>
    //     <path
    //       d="M5.636621 10.7824771L3.3573694 8.6447948c-.4764924-.4739011-.4764924-1.2418639 0-1.7181952.4777142-.473901 1.251098-.473901 1.7288122 0l1.260291 1.1254782 2.8256927-4.5462307c.3934117-.5431636 1.1545778-.6695372 1.7055985-.278265.5473554.3912721.6731983 1.150729.2797866 1.6951077l-3.6650524 5.709111c-.2199195.306213-.5803433.5067097-.9920816.5067097-.3225487 0-.6328797-.1263736-.8637952-.3560334z"
    //       fill="#FFF"
    //     />
    //   </g>
    // </svg>

    <svg className={className} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 2C0.75 1.30964 1.30964 0.75 2 0.75H20C20.6904 0.75 21.25 1.30964 21.25 2V20C21.25 20.6904 20.6904 21.25 20 21.25H2C1.30964 21.25 0.75 20.6904 0.75 20V2Z" stroke="black" strokeOpacity="0.6" strokeWidth="1.5" />
      <g filter="url(#filter0_i_2176_12459)">
        <rect className={classNames(checkedClassName || css.checked, {
          [css.availabilityChecked]: availabilityForm,
          [css.orderPanelChecked]: orderPanel,
          [css.checkoutPageChecked]: checkoutPage,
        }
        )} width="22" height="22" rx="2" fill="#EC5A46" />
      </g>
      <g className={boxClassName || css.box} clipPath="url(#clip0_2176_12459)">
        <path fillRule="evenodd" clipRule="evenodd" d="M17.3641 6.40732C17.5516 6.59484 17.6569 6.84915 17.6569 7.11432C17.6569 7.37948 17.5516 7.63379 17.3641 7.82132L9.86877 15.3166C9.76971 15.4157 9.65211 15.4943 9.52268 15.5479C9.39325 15.6016 9.25453 15.6292 9.11443 15.6292C8.97434 15.6292 8.83561 15.6016 8.70618 15.5479C8.57675 15.4943 8.45915 15.4157 8.3601 15.3166L4.6361 11.5933C4.54059 11.5011 4.46441 11.3907 4.412 11.2687C4.35959 11.1467 4.332 11.0155 4.33085 10.8827C4.32969 10.7499 4.355 10.6183 4.40528 10.4954C4.45556 10.3725 4.52981 10.2608 4.6237 10.1669C4.7176 10.073 4.82925 9.99878 4.95214 9.94849C5.07504 9.89821 5.20672 9.87291 5.3395 9.87407C5.47228 9.87522 5.6035 9.90281 5.7255 9.95521C5.84751 10.0076 5.95785 10.0838 6.0501 10.1793L9.1141 13.2433L15.9494 6.40732C16.0423 6.31439 16.1526 6.24067 16.2739 6.19038C16.3953 6.14008 16.5254 6.1142 16.6568 6.1142C16.7881 6.1142 16.9182 6.14008 17.0396 6.19038C17.161 6.24067 17.2712 6.31439 17.3641 6.40732Z" fill="white" />
      </g>
      <defs>
        <filter id="filter0_i_2176_12459" x="0" y="0" width="22" height="26" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2176_12459" />
        </filter>
        <clipPath id="clip0_2176_12459">
          <rect width="16" height="16" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>

  );
};

IconCheckbox.defaultProps = { className: null, checkedClassName: null, boxClassName: null };

IconCheckbox.propTypes = { className: string, checkedClassName: string, boxClassName: string };

const FieldCheckboxComponent = props => {
  const {
    rootClassName,
    className,
    svgClassName,
    textClassName,
    id,
    label,
    useSuccessColor,
    languageLogo,
    availabilityForm,
    planEntities,
    checkoutPage,
    orderPanel,
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  // This is a workaround for a bug in Firefox & React Final Form.
  // https://github.com/final-form/react-final-form/issues/134
  const handleOnChange = (input, event) => {
    const { onBlur, onChange } = input;
    onChange(event);
    onBlur(event);

    // If onChange has been passed as a props to FieldCheckbox
    if (rest.onChange) {
      rest.onChange(event);
    }
  };

  const successColorVariantMaybe = useSuccessColor
    ? {
      checkedClassName: css.checkedSuccess,
      boxClassName: css.boxSuccess,
    }
    : {};
  const disabledColorMaybe = rest.disabled
    ? {
      checkedClassName: css.checkedDisabled,
      boxClassName: css.boxDisabled,
    }
    : {};

  return (
    <span className={classes}>
      <Field type="checkbox" {...rest}>
        {props => {
          const { input, disabled } = props;
          return (
            <input
              id={id}
              className={classNames(css.input, { [css.availabilityInput]: availabilityForm, [css.checkoutPageInput]: checkoutPage } )}
              {...input}
              onChange={event => handleOnChange(input, event)}
              disabled={disabled}
            />
          );
        }}
      </Field>
      <label htmlFor={id} className={classNames(
        css.label, {
        [css.availabilityLabel]: availabilityForm,
        [css.planEntitiesLabel]: planEntities,
        [css.orderPanelLabel]: orderPanel,
        [css.checkoutPageLabel]: checkoutPage,
      }
      )}>
        <span>
          <IconCheckbox
            availabilityForm={availabilityForm}
            checkoutPage={checkoutPage}
            orderPanel={orderPanel}
            className={svgClassName}
            {...successColorVariantMaybe}
            {...disabledColorMaybe}
            />
        </span>
        <span className={classNames(css.text, textClassName || css.textRoot)}>{languageLogo} {label}</span>
      </label>
    </span>
  );
};

FieldCheckboxComponent.defaultProps = {
  className: null,
  rootClassName: null,
  svgClassName: null,
  textClassName: null,
  label: null,
};

FieldCheckboxComponent.propTypes = {
  className: string,
  rootClassName: string,
  svgClassName: string,
  textClassName: string,

  // Id is needed to connect the label with input.
  id: string.isRequired,
  label: node,

  // Name groups several checkboxes to an array of selected values
  name: string.isRequired,

  // Checkbox needs a value that is passed forward when user checks the checkbox
  value: string.isRequired,
};

export default FieldCheckboxComponent;
